(function() {
  'use strict';

  angular
    .module('boxdoxBb', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria',
    'ui.router',
    'toastr','perfect_scrollbar','ngTable','angulartics', 'angulartics.google.analytics']);

})();

(function() {
  'use strict';

  angular
    .module('boxdoxBb')
    .controller('ViewerController', ViewerController);

  /** @ngInject */
  function ViewerController($http, $log, $state, toastr, boxdoxData) {
    var vm = this;
    vm.selectGame = selectGame;
    vm.selectCharacter = selectCharacter;
    vm.selectScript = selectScript;
    vm.selectCommand = selectCommand;
    vm.getCommandClass = getCommandClass;
    vm.scriptHasHitbox = scriptHasHitbox;
    vm.selectedGame = $state.params.game || "bbcf_200";
    vm.selectedCharacter = $state.params.character || "jb";
    vm.selectedSub = $state.params.sub || 0;
    vm.selectedScriptName = $state.params.script || "CmnActStand";
    vm.selectedCommand = $state.params.index || 0;
    activate();

    function activate() {
      selectGame();
    }

    function selectGame() {
      var res;
      if (vm.selectedGame.startsWith("bb")) {
        res = 'bbcf';
      } else {
        res = 'gg_revelator';
      }
      boxdoxData.getCommandDBForGame(res).then(function(commandDB) {
        vm.commandDB = commandDB;
      });
      boxdoxData.getCharactersForGame(res).then(function(characters) {
        vm.characters = characters;
        selectCharacter().then(function() {
          if ($state.params.script)
            selectScriptIndexByName($state.params.script);
          if ($state.params.index)
            selectCommand($state.params.index);
        });

      }, function errorCallback(response) {
        toastr.error('Error retreiving character list! ' + response.statusText, 'Error!');
      });
    }

    function selectCharacter() {
      vm.loadedCharacterData = undefined;
      return boxdoxData.getCharacterData(vm.selectedGame, vm.selectedCharacter).then(function(data) {
        vm.loadedCharacterData = data;
        if(!$state.params.script)
          $state.go("viewer.game.character", {
            game: vm.selectedGame,
            character: vm.selectedCharacter
          });
      });

    }

    function selectScript(index, route) {
      vm.selectedScriptName = vm.loadedCharacterData["scr"][vm.selectedSub].data.Functions[index].name;
      vm.selectedScriptIndex = index;
        $state.go("viewer.game.character.script", {
          game: vm.selectedGame,
          character: vm.selectedCharacter,
          script: vm.selectedScriptName
        });
      var frame = 0;
      var nextSpriteFrame = 0;
      var indent = 0;
      angular.forEach(vm.loadedCharacterData["scr"][vm.selectedSub].data.Functions[index].commands, function(command, index2) {
        var nextCommand = vm.loadedCharacterData["scr"][vm.selectedSub].data.Functions[index].commands[index2 + 1];
        if ($.inArray(command.id, [1, 5, 9, 16, 55, 57, 14002]) > -1)
          indent--;
        command.indent = indent;
        if ($.inArray(command.id, [0, 4, 8, 15, 54, 56, 14001]) > -1)
          indent++;
        if (command.id == 56 && nextCommand.id == 40) {
          indent--;
        }
        if (indent < 0)
          indent = 0;
        command.frame = frame;
        if (command.id == 2) {
          command.frame = nextSpriteFrame+1;
          frame = command.frame;

          nextSpriteFrame = frame + Number(command.params[1]-1);
          command.frame += "-" + nextSpriteFrame;
        }
      });
    }

    function selectScriptIndexByName(name) {
      var script = $(vm.loadedCharacterData["scr"][0].data.Functions).filter(function(index, el) {
        return el.name == name
      })[0];
      if (!script) {
        script = $(vm.loadedCharacterData["scr"][1].data.Functions).filter(function(index, el) {
          return el.name == name
        })[0];
        vm.selectedSub = 1;
      }
      selectScript(vm.loadedCharacterData["scr"][vm.selectedSub].data.Functions.indexOf(script));
    }

    function selectCommand(index) {
      vm.images = [];
      vm.selectedCommand = index;
      $state.go("viewer.game.character.script.index", {
        game: vm.selectedGame,
        character: vm.selectedCharacter,
        script: vm.selectedScriptName,
        index: vm.selectedCommand
      });
      var tmpIndex = index;
      var selectedCommandObj = {};
      while (index >= 0 && selectedCommandObj.id != 2) {
        selectedCommandObj = vm.loadedCharacterData["scr"][vm.selectedSub].data.Functions[vm.selectedScriptIndex].commands[index--];
      }
      if (selectedCommandObj.id == 2) {

        var imageName = selectedCommandObj.params[0].replace(/'/g, "");
        var jonbin;
        if (vm.selectedGame.startsWith("bb")) {
          jonbin = vm.loadedCharacterData["col"][imageName + ".jonbin"];
        } else {
          jonbin = vm.loadedCharacterData["col"][imageName];
        }

        vm.selectedFrame = jonbin;
      } else {
        vm.selectedFrame = undefined;
      }
    }

    function getCommandClass(command, index) {
      var classes = [];
      if (index == vm.selectedCommand)
        classes.push('active');
      else if (commandHasHitbox(command))
        classes.push('danger');
      else if (command.id == 2)
        classes.push('info');
      else if (command.id < 100)
        classes.push('warning');

      return classes;

    }
    function commandHasHitbox(command)
    {
      if(command.id == 2) {
        var jonbin;
        if (vm.selectedGame.startsWith("bb")) {
          jonbin = vm.loadedCharacterData["col"][command.params[0] + ".jonbin"];
        } else {
          jonbin = vm.loadedCharacterData["col"][command.params[0]];
        }
        if(jonbin)
          return jonbin.Hitboxes.length > 0;
      }
      return false;
    }
    function scriptHasHitbox(script) {
      var hit = $(script.commands).filter(function(i, command) {
        return commandHasHitbox(command);
      });
      if (hit.length == 0)
        return "list-group-item";
      return "list-group-item list-group-item-info"
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('boxdoxBb')
    .controller('RawViewerController', RawViewerController);

  /** @ngInject */
  function RawViewerController($http, $log, $state, toastr) {
    var vm = this;
    vm.selectedGame = $state.params.game || "bbcf";
    vm.selectedCharacter = $state.params.character || "kk";
    activate();

    function activate() {
      selectCharacter();
    }
    function selectCharacter(route) {
      return $http({
        method: 'GET',
        url: '/db/'+vm.selectedGame+'/scr_' + vm.selectedCharacter + '.bin.py'
      }).then(function successCallback(response) {
        vm.code = Prism.highlight(response.data,Prism.languages.python);
      }, function errorCallback(response) {
        toastr.error('Error retreiving character script! ' + response.statusText, 'Error!');
      });

    }
  }
})();

(function() {
  'use strict';

  angular
    .module('boxdoxBb')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController() {
    var vm = this;
    vm.creationDate = 1470330482230;

    activate();

    function activate() {

    }
  }
})();

(function() {
  'use strict';

  angular
    .module('boxdoxBb')
    .controller('FrameDataController', FrameDataController);
  /** @ngInject */
  function FrameDataController($http,$log,$state,toastr) {
    var vm = this;
    vm.selectedCharacter = $state.params.character || "kk";
    vm.selectCharacter = selectCharacter;
    vm.calculatedData = [];
    activate();

    function activate() {
      $http({
        method: 'GET',
        url: '/static_db/bb/characters.json'
      }).then(function successCallback(response)
      {
        vm.characters = response.data;
        selectCharacter();
      });
    }

    function selectCharacter() {
      return $http({
        method: 'GET',
        url: '/db/bbcpex/' + vm.selectedCharacter + '.json'
      }).then(function successCallback(response) {
        vm.scripts = response.data["scr"][0].data;

        calculateData();
        $state.go("frameData.game.character", {
          game: 'bbcpex',
          character: vm.selectedCharacter
        });
      }, function errorCallback(response) {
        toastr.error('Error retreiving character script! ' + response.statusText, 'Error!');
      });
    }
    function calculateData()
    {
      vm.calculatedData = [];
      angular.forEach(vm.scripts.Functions, function(script,index)
      {

        var hit = $(script.commands).filter(function(i,command){
          return command.name == "AttackLevel?";
        });
        if(hit.length == 0)
          return;
        var tmp = {name:script.name,badges:{},guard:{}};
        var hits = 0;
        angular.forEach(script.commands, function(command,index)
        {
          if(command.name == "AttackLevel?")
          {
            tmp.AttackLevel = command.params[0];
            if(tmp.AttackLevel == 1)
            {
              tmp.Damage = 300;
              tmp.P1 = 100;
              tmp.P2 = 77;
            }
            if(tmp.AttackLevel == 2)
            {
              tmp.Damage = 500;
              tmp.P2 = 89;
            }
            if(tmp.AttackLevel == 3)
            {
              tmp.P1 = 100;
              tmp.P2 = 89;
            }
            if(tmp.AttackLevel == 4)
            {
              tmp.P1 = 100;
              tmp.P2 = 92;
            }
            if(tmp.AttackLevel == 5)
            {
              tmp.P1 = 100;
              tmp.P2 = 84;
            }
          }
          if(command.name == "cond2" && command.params[0] != 0)
            tmp.badges["Conditional"] = "label-default";
          if(command.name == "Unknown2000")
            tmp.badges["Multihit"] = "label-info";
          if(command.name == "HitLow?")
            tmp.guard["Low?"] = "label-info";
          if(command.name == "Unknown11088")
            tmp.guard["Over?"] = "label-info";
          if(command.name == "Unknown17000")
            tmp.badges["Body"] = "label";
          if(command.name == "Unknown17001")
            tmp.badges["Head"] = "label";
          if(command.name == "Unknown17006")
            tmp.badges["Feet"] = "label";
          if(command.name == "Unknown21007")
            tmp.badges["Projectile"] = "label";
          if(command.name == "AttackP1")
            tmp.P1 = command.params[0];
          if(command.name == "Damage")
            tmp.Damage = command.params[0];
        });
        vm.calculatedData.push(tmp);
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('boxdoxBb')
    .controller('DiffController', DiffController);

  /** @ngInject */
  function DiffController($http, $log, $state, toastr, boxdoxData, $q) {
    var vm = this;
    vm.selectedDiff = {};
    vm.loadCharacters = loadCharacters;
    vm.diffCharacter = diffCharacter;

    vm.changes = [];
    this.diffChoices = [{
      "name": "Revelator 1.03 -> 1.04",
      "baseGame": "gg_revelator",
      "fromGame": "gg_revelator_103",
      "toGame": "gg_revelator_104"
    },{
      "name": "Revelator 1.02 -> 1.03",
      "baseGame": "gg_revelator",
      "fromGame": "gg_revelator_102",
      "toGame": "gg_revelator_103"
    },
    {
      "name": "BBCSEX -> BBCP",
      "baseGame": "bb",
      "fromGame": "bbcsex",
      "toGame": "bbcp"
    },
    {
      "name": "BBCP -> BBCPEX",
      "baseGame": "bb",
      "fromGame": "bbcp",
      "toGame": "bbcpex"
    },
    {
      "name": "BBCPEX -> BBCF",
      "baseGame": "bb",
      "fromGame": "bbcpex",
      "toGame": "bbcf"
    },
    {
      "name": "BBCF 1.0 -> BBCF 1.02",
      "baseGame": "bb",
      "fromGame": "bbcf_100",
      "toGame": "bbcf_102"
    },
    {
      "name": "BBCF 1.02 -> BBCF 2.0",
      "baseGame": "bb",
      "fromGame": "bbcf_102",
      "toGame": "bbcf_200"
    }
    ];
    activate();

    function activate() {}

    function loadCharacters() {
      boxdoxData.getCharactersForGame(vm.selectedDiff.baseGame).then(function(data) {
        vm.characters = data;
      });
      boxdoxData.getCommandDBForGame(vm.selectedDiff.baseGame).then(function(data) {
        vm.commandDB = data;
      });
    }
    function script2Str(script)
    {
      var commandStrs = [];
      var indent = 0;
      angular.forEach(script.commands, function(command, index2) {
        var nextCommand = script.commands[index2 + 1];
        if ($.inArray(command.id, [1, 5, 9, 16, 55, 57, 14002]) > -1)
          indent--;
        command.indent = indent;
        if (command.indent < 0)
          command.indent = 0;
        if ($.inArray(command.id, [0, 4, 8, 15, 54, 56, 14001]) > -1)
          indent++;

        if (command.id == 56 && nextCommand.id == 40) {
          indent--;
        }
        if (indent < 0)
          indent = 0;
        var commandName = command.id.toString();
        if(vm.commandDB[command.id] && vm.commandDB[command.id].name)
          commandName = vm.commandDB[command.id].name;
        commandStrs.push(commandName + "(" + command.params.join() +")");
      });
      return commandStrs.join("\n");
    }
    function diffCharacter() {
      var fromData;
      var toData;
      var getFromData = boxdoxData.getCharacterData(vm.selectedDiff.fromGame, vm.selectedCharacter).then(function(data) {
        fromData = data;
      });
      var getToData = boxdoxData.getCharacterData(vm.selectedDiff.toGame, vm.selectedCharacter).then(function(data) {
        toData = data;
      });

      $q.all([getFromData, getToData]).then(function() {
        vm.changes = [];
        var sourceCollection;
        var pyMode = fromData["scr"][0].data.FunctionsPy.length != 0;
        if(pyMode)
        {
          sourceCollection = fromData["scr"][0].data.FunctionsPy;
        }
        else {
          sourceCollection = fromData["scr"][0].data.Functions;
        }
        angular.forEach(sourceCollection, function(fromScript, index) {
          var toScript;
          if(pyMode) {
            toScript = $(toData["scr"][0].data.FunctionsPy).filter(function(i, script) {
              return script.name == fromScript.name
            })[0];
          }
          else {
            toScript = $(toData["scr"][0].data.Functions).filter(function(i, script) {
              return script.name == fromScript.name
            })[0];

          }

          if(!toScript)
            return;
          if(JSON.stringify(fromScript) != JSON.stringify(toScript))
          {
            /*
            var dmp = new diff_match_patch();
            var a;
            if(pyMode) {
              a = dmp.diff_linesToChars_(fromScript.src, toScript.src);
            }
            else {
              a = dmp.diff_linesToChars_(script2Str(fromScript), script2Str(toScript));
            }
            var lineText1 = a.chars1;
            var lineText2 = a.chars2;
            var lineArray = a.lineArray;

            var diff = dmp.diff_main(lineText1, lineText2, false);
            dmp.diff_charsToLines_(diff, lineArray);
            dmp.diff_cleanupSemantic(diff);
            var ds = dmp.diff_prettyHtml(diff);

            vm.changes.push({"name":fromScript.name,"data":ds})
            */
            var fromStr;
            var toStr;
            if(pyMode) {
              fromStr = fromScript.src;
              toStr = toScript.src;
            }
            else {
              fromStr = script2Str(fromScript);
              toStr = script2Str(toScript);
            }
            var diff = difflib.unifiedDiff(fromStr.split('\n'),
                     toStr.split('\n'), {
                       n:1000,
                       lineterm: '',
                     })
            vm.changes.push({"name":fromScript.name,"data":diff});

          }



        })
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('boxdoxBb')
    .controller('CommandDBController', CommandDBController);
  /** @ngInject */
  function CommandDBController($http,NgTableParams,$state) {
    var vm = this;
    vm.title = $state.params.game;
    activate();

    function activate() {
      $http({
        method: 'GET',
        url: '/static_db/'+$state.params.game+'/commandDB.json'
      }).then(function successCallback(response)
      {
        var data = [];
        angular.forEach(response.data, function(value,key)
        {
          value.id = key;
          value.group = Math.floor(key/100)*100;
          data.push(value);
        });

        vm.tableParams = new NgTableParams({group:"group",count: data.length}, { counts:[],dataset: data });
        vm.commands = data;
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('boxdoxBb')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController() {
      var vm = this;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('boxdoxBb')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el) {
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 5000,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });
    }

    /** @ngInject */
    function MalarkeyController() {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {

      }

    }

  }

})();

(function() {
  'use strict';

  angular
    .module('boxdoxBb')
    .directive('bdFramedisplay', frameDisplay);

  /** @ngInject */
  function frameDisplay() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/frameDisplay/frameDisplay.html',
      scope: {
        src: "="
      },
      controller: FrameDisplayController,
      controllerAs: 'vm',
      bindToController: true,
      link: function(scope,element,attrs)
      {
        $(element).addClass("frameDisplay");
        scope.element = element;
      }
    };

    return directive;

    /** @ngInject */
    function FrameDisplayController($scope) {
      var vm = this;
      vm.showSprites = true;
      vm.showHurtboxes = true;
      vm.showHitboxes = true;
      vm.showOther = true;
      vm.RefreshView = RefreshView;
      $scope.$watch(function(){return vm.src}, RefreshView);
      function RefreshView() {

        var jonbin = vm.src;
        vm.images = [];
        if(!jonbin)
          return;
        if(!$scope.$parent.viewer.loadedCharacterData["hipoffset"])
          vm.showSprites = false;
        var imageName = jonbin.Images[0].replace(".bmp","");
        var width = $($scope.element).width()-250;
        var height = $($scope.element).height() - 150;

        if(vm.showSprites)
        {
          var imagePrefix = imageName.substr(0,2);
          var imagePath = "/db/bbcf_200/img/" +imagePrefix + "/" + imageName + ".png";
          var imageOffset = $scope.$parent.viewer.loadedCharacterData["hipoffset"][imageName + ".hip"];
          angular.forEach(jonbin.Chunks, function(el) {

            var tmp = {}
            tmp.css = {
              background: ' url("' + imagePath + '") no-repeat',
              "background-position": (el.SrcX + imageOffset[0]) + "px " + (el.SrcY + imageOffset[1]) + "px",
              'z-index': el.Layer,
              position: 'absolute',
              width: (el.Width) + 'px',
              height: (el.Height) + 'px',
              left: (width + el.X) + 'px',
              top: (height + el.Y) + 'px'
            };
            vm.images.push(tmp);
          })
        }
        if(vm.showHurtboxes)
          angular.forEach(jonbin.Hurtboxes, function(el) {
            var tmp = {}
            tmp.css = {
              border: "1px solid blue",
              position: 'absolute',
              width: (el.Width) + 'px',
              height: (el.Height) + 'px',
              left: (width + el.X) + 'px',
              top: (height + el.Y) + 'px'
            };
            vm.images.push(tmp);
          });
        if(vm.showHitboxes)
          angular.forEach(jonbin.Hitboxes, function(el) {
            var tmp = {}
            tmp.css = {
              border: "1px solid red",
              position: 'absolute',
              width: (el.Width) + 'px',
              height: (el.Height) + 'px',
              left: (width + el.X) + 'px',
              top: (height + el.Y) + 'px'
            };
            vm.images.push(tmp);
          });
        if(vm.showOther)
          angular.forEach(jonbin.BoxType3, function(el) {
            var tmp = {}
            tmp.css = {
              border: "1px solid red",
              position: 'absolute',
              width: (el.Width) + 'px',
              height: (el.Height) + 'px',
              left: (width + el.X) + 'px',
              top: (height + el.Y) + 'px'
            };
            vm.images.push(tmp);
          });
      }

    }
  }
})();

(function() {
    'use strict';

    angular
      .module('boxdoxBb')
      .service('boxdoxLocalOptions', boxdoxLocalOptions);

    /** @ngInject */
    function boxdoxLocalOptions() {
      this.OffsetX = 0;
      this.OffsetY = 0;
      this.Zoom = 0;
    }

})();

(function() {
  'use strict';

  angular
    .module('boxdoxBb')
    .service('boxdoxData', boxdoxData);

  /** @ngInject */
  function boxdoxData($http,toastr) {
    this.getCommandDBForGame = getCommandDBForGame;
    this.getCharactersForGame = getCharactersForGame;
    this.getCharacterData = getCharacterData;
    function getCommandDBForGame(game) {
      return $http({
        method: 'GET',
        url: '/static_db/' + game + '/commandDB.json'
      }).then(function successCallback(response) {
        return response.data;
      });
    }

    function getCharactersForGame(game) {
      return $http({
        method: 'GET',
        url: '/static_db/' + game + '/characters.json'
      }).then(function successCallback(response) {
        var characters = {};
        angular.forEach(response.data, function(key, value) {
          characters[value] = response.data[value];
        });
        return characters;
      });
    }
    function getCharacterData(game,character){
      return $http({
        method: 'GET',
        url: '/db/'+game+'/' + character + '.json'
      }).then(function successCallback(response) {
        return response.data;
      }, function errorCallback(response) {
        toastr.error('Error retreiving character script! ' + response.statusText, 'Error!');
      });
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('boxdoxBb')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {


  }

})();

(function() {
  'use strict';

  angular
    .module('boxdoxBb')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('viewer', {
        url: '/viewer',
        templateUrl: 'app/controllers/viewer/viewer.html',
        controller: 'ViewerController',
        controllerAs: 'viewer'
      })
      .state('viewer.game', {
        url: '/:game'
      })
      .state('viewer.game.character', {
        url: '/:character'
      })
      .state('viewer.game.character.script', {
        url: '/:script'
      })
      .state('viewer.game.character.script.index', {
        url: '/:index'
      })

      .state('raw-viewer', {
        url: '/raw-viewer/:game/:character',
        templateUrl: 'app/controllers/raw-viewer/raw-viewer.html',
        controller: 'RawViewerController',
        controllerAs: 'viewer'
      })
      .state('diff', {
        url: '/diff',
        templateUrl: 'app/controllers/diff/diff.html',
        controller: 'DiffController',
        controllerAs: 'diff'
      })
      .state('diff.game', {
        url: '/:game'
      })
      .state('diff.game.character', {
        url: '/:character'
      })
      .state('diff.game.character.script', {
        url: '/:script'
      })
      .state('commandDB', {
        url: '/commandDB/:game',
        templateUrl: 'app/controllers/commandDB/commandDB.html',
        controller: 'CommandDBController',
        controllerAs: 'commandDB'
      })
      .state('frameData', {
        url: '/frameData',
        templateUrl: 'app/controllers/framedata/framedata.html',
        controller: 'FrameDataController',
        controllerAs: 'frameData'
      })
      .state('frameData.game', {
        url: '/:game'
      })
      .state('frameData.game.character', {
        url: '/:character'
      })
      .state('home', {
        url: '/',
        templateUrl: 'app/controllers/main/main.html',
        controller: 'MainController',
        controllerAs: 'main'
      });

    $urlRouterProvider.otherwise('/');
  }

})();

/* global malarkey:false,difflib:false  */
(function() {
  'use strict';

  angular
    .module('boxdoxBb')
    .constant('malarkey', malarkey)
    .constant('Prism', Prism)
    .constant('difflib', difflib);

})();

(function() {
  'use strict';

  angular
    .module('boxdoxBb')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
  }

})();

angular.module("boxdoxBb").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/frameDisplay/frameDisplay.html","<div ng-repeat=\"(index, image) in vm.images\" ng-style=image.css>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\"><div class=container-fluid><div class=navbar-header><button type=button class=\"navbar-toggle collapsed\" ng-click=\"isCollapsed = !isCollapsed\" aria-expanded=false><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button> <a class=navbar-brand href=#><span class=\"glyphicon glyphicon-home\"></span> boxdox.bb</a></div><div class=\"collapse navbar-collapse\" uib-collapse=isCollapsed><ul class=\"nav navbar-nav\"><li class=active><a ng-href=#>Home</a></li><li><a ng-href=#/viewer>Viewer</a></li><li><a ng-href=#/diff>Diff</a></li><li><a ng-href=#/frameData>Framedata Table</a></li><li class=dropdown><a class=dropdown-toggle data-toggle=dropdown role=button aria-haspopup=true aria-expanded=false>Command DB <span class=caret></span></a><ul class=dropdown-menu><li><a ng-href=#/commandDB/bb>Blazblue</a></li><li><a ng-href=#/commandDB/gg_revelator>GG Xrd</a></li></ul></li></ul><ul class=\"nav navbar-nav navbar-right acme-navbar-text\"><li><a href=http://twitter.com/dantarion>This tool brought to you by @dantarion</a></li></ul></div></div></nav>");
$templateCache.put("app/controllers/commandDB/commandDB.html","<div class=container><div><acme-navbar creation-date=main.creationDate></acme-navbar></div><h1>{{commandDB.title}}</h1><table class=\"table table-bordered table-condensed\" ng-table=commandDB.tableParams show-filter=0><tr class=ng-table-group ng-repeat-start=\"group in $groups\"><td colspan=3><a href=\"\" ng-click=\"group.$hideRows = !group.$hideRows\" style=font-size:150%><span class=glyphicon ng-class=\"{ \'glyphicon-chevron-right\': group.$hideRows, \'glyphicon-chevron-down\': !group.$hideRows }\"></span> {{ group.value }} - {{ group.value+100 }}</a></td></tr><tr ng-hide=group.$hideRows ng-repeat-end ng-repeat=\"command in group.data\"><td data-title=\"\'ID\'\">{{command.id}}</td><td data-title=\"\'Name\'\">{{command.name}}</td><td data-title=\"\'Format\'\">{{command.format}}</td></tr></table></div>");
$templateCache.put("app/controllers/diff/diff.html","<div class=container><div><acme-navbar></acme-navbar></div></div><div class=container><h3>Choose a Diff Type</h3><select class=form-control ng-options=\"diffChoice.name for diffChoice in diff.diffChoices\" n ng-model=diff.selectedDiff ng-change=diff.loadCharacters()></select><h4>Choose a Character</h4><select class=form-control ng-model=diff.selectedCharacter ng-change=diff.diffCharacter() ng-model=diff.selectedCharacter><option ng-repeat=\"(charCode,charName) in diff.characters\" value={{charCode}}>{{charName}}</option></select><div ng-repeat=\"change in diff.changes\"><h4 id=change-id-{{change.name}}>{{change.name}}</h4><div style=\"white-space: pre; font-family: Consolas, fixed-width; overflow-\"><div ng-repeat=\"line in change.data track by $index\" ng-class=\"{\'ins\':line[0] == \'+\', \'del\':line[0] == \'-\'}\">{{line}}</div></div></div></div>");
$templateCache.put("app/controllers/framedata/framedata.html","<div class=container><div><acme-navbar creation-date=main.creationDate></acme-navbar></div></div><div class=container-fluid><select class=\"form-control input-sm\"><option value=bbcpex>Blazblue Chronophantasma Extend</option></select><select class=\"form-control input-sm\" ng-model=frameData.selectedCharacter ng-change=frameData.selectCharacter()><option ng-repeat=\"(charCode,charName) in frameData.characters\" value={{charCode}}>{{charName}}</option></select><table class=\"table table-bordered table-condensed\"><tr><th>Name</th><th>Damage</th><th>P1</th><th>P2</th><th>Guard</th><th>AttackLevel</th></tr><tr ng-repeat=\"data in frameData.calculatedData\"><td>{{data.name}}</td><td>{{data.Damage}}</td><td>{{data.P1}}</td><td>{{data.P2}}</td><td><span class=label ng-class={{data.class}} ng-repeat=\"(text,class) in data.guard\">{{text}}</span></td><td>{{data.AttackLevel}}</td><td><span class=label ng-class={{data.class}} ng-repeat=\"(text,class) in data.badges\">{{text}}</span></td><td>{{data}}</td></tr></table></div>");
$templateCache.put("app/controllers/main/main.html","<div class=container><div><acme-navbar creation-date=main.creationDate></acme-navbar></div><div class=\"jumbotron text-center\"><img class=\"pull-right img-rounded\" src=http://i.imgur.com/CDqhcf9.png><h1>Get the information you need.</h1><p class=lead>This website provides technical data about the internals of a few Arc System Works games that share a scripting engine. These games include the Blazblue series, Persona 4 Arena Series, and Guilty Gear Series(Xrd and Revelator only). Here you will find hitboxes, framedata, as well as information about the scripting language ArcSys made to drive these games.</p><p>With ♥ thanks to the contributions of<acme-malarkey extra-values=\"[\'@dantarion\', \'@appleken\',\'@logichole\']\"></acme-malarkey></p></div><div class=row id=gameSelector><div class=\"col-sm-6 col-md-4\"><a ng-href=#/viewer/bbcf/kk/NmlAtk5A/31><h3>Blazblue</h3><img class=img-responsive src=/assets/images/games/bbcp.jpeg></a></div><div class=\"col-sm-6 col-md-4\"><a ng-href=#/viewer/gg_revelator_103/FAU/NmlAtk6A/13><h3>GG Xrd Revelator</h3><img class=img-responsive src=/assets/images/games/ggxrev.jpg></a></div><div class=\"col-sm-6 col-md-4\"><h3>zzz coming soon</h3><img class=img-responsive src=/assets/images/games/p4au.jpg></div></div></div>");
$templateCache.put("app/controllers/raw-viewer/raw-viewer.html","<div class=container><div><acme-navbar></acme-navbar></div></div><div class=\"container-fluid code\" ng-bind-html=viewer.code style=white-space:pre></div>");
$templateCache.put("app/controllers/viewer/viewer.html","<div class=container><div><acme-navbar></acme-navbar></div></div><div id=sidebar><perfect-scrollbar class=scroller wheel-propagation=true wheel-speed=2 min-scrollbar-length=60 suppressscrollx=true><select class=\"form-control input-sm\" ng-model=viewer.selectedGame ng-change=viewer.selectGame()><option value=bbcsex>BBCSEX</option><option value=bbcp>BBCP</option><option value=bbcpex>BBCPEX</option><option value=bbcf_100>BBCF 1.00</option><option value=bbcf_102>BBCF 1.02</option><option value=bbcf_200>BBCF 2.00</option><option value=gg_revelator_102>GGXrd Revelator 1.02</option><option value=gg_revelator_103>GGXrd Revelator 1.03</option><option value=gg_revelator_104>GGXrd Revelator 1.04</option></select><select class=\"form-control input-sm\" ng-model=viewer.selectedCharacter ng-change=viewer.selectCharacter()><option ng-repeat=\"(charCode,charName) in viewer.characters\" value={{charCode}}>{{charName}}</option></select><div><label class=radio-inline><input ng-model=viewer.selectedSub type=radio ng-value=0> Character</label><label class=radio-inline><input ng-model=viewer.selectedSub type=radio ng-value=1> Etc</label></div><a ng-href=/#/raw-viewer/{{viewer.selectedGame}}/{{viewer.selectedCharacter}}>View Raw</a><div class=\"list-group scrollContainer\"><a class=list-group-item ng-class=viewer.scriptHasHitbox(script,index) ng-repeat=\"(index,script) in viewer.loadedCharacterData[\'scr\'][viewer.selectedSub].data.Functions\" ng-click=viewer.selectScript(index)>{{script.name}}</a></div></perfect-scrollbar></div><div id=sidebar2><perfect-scrollbar class=scroller wheel-propagation=true wheel-speed=2 suppressscrollx=false><table class=\"codeContainer table table-condensed\"><tr><th>Frame</th><th>Command</th></tr><tr ng-click=viewer.selectCommand(index) ng-class=viewer.getCommandClass(command,index) ng-repeat=\"(index,command) in viewer.loadedCharacterData[\'scr\'][viewer.selectedSub].data.Functions[viewer.selectedScriptIndex].commands\"><td ng-bind=command.frame></td><td style=\"border-left:1px solid #666\"><span ng-repeat=\"n in [].constructor(command.indent) track by $index\">&nbsp;&nbsp;</span> {{viewer.commandDB[command.id].name ? viewer.commandDB[command.id].name : \"Unknown\"+command.id }}(<span ng-repeat=\"param in command.params track by $index\">{{param}}{{$last ? \'\' : \', \'}}</span>) <span ng-if=command.comment style=color:white>#{{command.comment}}</span></td></tr></table></perfect-scrollbar></div><div class=\"container-fluid container-sidebar\"><div id=stageCanvas><bd-framedisplay src=viewer.selectedFrame></bd-framedisplay></div></div>");}]);